import forBasicControl from "./forBasicControl";
import { IControlProps, IDateRangeControl } from "./types";
import React from "react";
import { FormGroup, Input, FormFeedback, InputGroup, InputGroupAddon, Button, Row, Col, Label } from "reactstrap";
import { createLabel } from "./BasicControls";

import Calendar, { CalendarTileProperties } from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import './DateRangeControl.scss';
import enhanceWithClickOutside from 'react-click-outside';
import moment, { Moment } from "moment";
import { LocaleSettings } from "../../global/formatting";
import { ForceableTimer } from "../../global/ForceableTimer";

interface IState {
    expand: 'focus' | 'click' | false;
    start: Moment;
    startDate: Date;
    startText: string;
    startDirty: boolean;
    end: Moment
    endDate: Date;
    endText: string;
    endDirty: boolean;
}
const dateFormat = [
    'DD-MM-YYYY',
    'DD-MM-Y',
    'YYYY-MM-DD',
];
class DateRangeControl extends React.PureComponent<IControlProps<{ startDate: Moment, endDate: Moment }, IDateRangeControl>, IState> {
    private controlRef;

    constructor(props: IControlProps<{ startDate: Moment, endDate: Moment }, IDateRangeControl>) {
        super(props);
        this.state = {
            expand: false,
            start: null,
            startDate: null,
            startText: '',
            startDirty: false,
            end: null,
            endDate: null,
            endText: '',
            endDirty: false,
        }
    }

    public componentDidMount() {

        this.setState({
            //className: this.createStyleClass(),
            start: this.props.value ? this.props.value.startDate : null,
            startDate: this.props.value && this.props.value.startDate ? this.props.value.startDate.toDate() : null,
            startText: this.props.value && this.props.value.startDate ? this.props.value.startDate.locale(LocaleSettings.Locale).format(LocaleSettings.DateFormat) : '',
            end: this.props.value ? this.props.value.endDate : null,
            endDate: this.props.value && this.props.value.endDate ? this.props.value.endDate.toDate() : null,
            endText: this.props.value && this.props.value.endDate ? this.props.value.endDate.locale(LocaleSettings.Locale).format(LocaleSettings.DateFormat) : '',
        });
    }

    public componentDidUpdate(prev: IControlProps<{ startDate: Moment, endDate: Moment }, IDateRangeControl>) {
        if (this.props.value !== prev.value) {
            const startDate = this.props.value && this.props.value.startDate && this.props.value.startDate.isValid() ? this.props.value.startDate.toDate() : null;
            const endDate = this.props.value && this.props.value.endDate && this.props.value.endDate.isValid() ? this.props.value.endDate.toDate() : null;

            if (this.state.startDirty || this.state.endDirty)
                return;

            if (startDate !== this.state.startDate || endDate !== this.state.endDate) {

                this.setState({
                    start: startDate ? this.props.value.startDate : null,
                    startDate,
                    startText: startDate ? this.props.value.startDate.locale(LocaleSettings.Locale).format(LocaleSettings.DateFormat) : '',
                    end: endDate ? this.props.value.endDate : null,
                    endDate,
                    endText: endDate ? this.props.value.endDate.locale(LocaleSettings.Locale).format(LocaleSettings.DateFormat) : '',
                });
            }
        }
    }

    private onChangeStart(value: Date) {
        if (value === this.state.startDate)
            return;

        this.blurDelay.clear();

        const update = value ? moment(value) : null;
        this.setState({
            expand: 'click',
            start: update,
            startDate: value,
            startDirty: false,
            startText: update ? update.locale(LocaleSettings.Locale).format(LocaleSettings.DateFormat) : ''
        });

        this.props.onChange({ startDate: update, endDate: this.state.end }, true);
    }
    private onChangeEnd(value: Date) {
        if (value === this.state.endDate)
            return;
            
        this.blurDelay.clear();

        const update = value ? moment(value) : null;
        this.setState({
            expand: 'click',
            end: update,
            endDate: value,
            endDirty: false,
            endText: update ? update.locale(LocaleSettings.Locale).format(LocaleSettings.DateFormat) : ''
        });

        this.props.onChange({ startDate: this.state.start, endDate: update }, true);
    }
    private tileClass(props: CalendarTileProperties, active: Date): string {
        if (this.state.startDate && this.state.endDate && props.date !== active) {
            if (props.date >= this.state.startDate && props.date <= this.state.endDate) {
                return 'react-calendar-range-tile';
            }
        }
    }
    public handleClickOutside() {
        if (this.state.expand) {
            this.setState({ expand: false });
        }
    }
    private blurDelay = new ForceableTimer(500);
    private onFocus() {
        this.blurDelay.clear();

        if (!this.state.expand)
            this.setState({ expand: 'focus' });
    }
    private onBlur() {
        if (this.state.expand === 'focus')
            this.blurDelay.reset(() => this.setState({ expand: false }));

        if (this.state.startDirty || this.state.endDirty) {
            this.setState({
                startText: this.state.start ? this.state.start.locale(LocaleSettings.Locale).format(LocaleSettings.DateFormat) : '',
                endText: this.state.end ? this.state.end.locale(LocaleSettings.Locale).format(LocaleSettings.DateFormat) : '',
            });

            this.props.onChange({ startDate: this.state.start, endDate: this.state.end }, true);
        }
    }
    private onChangeStartText(value: string) {
        const date = value ? moment(value, dateFormat) : null;

        this.setState({
            start: date,
            startDate: date && date.isValid() ? date.toDate() : null,
            startDirty: true,
            startText: value,
        });
    }
    private onChangeEndText(value: string) {
        const date = value ? moment(value, dateFormat) : null;

        this.setState({
            end: date,
            endDate: date && date.isValid() ? date.toDate() : null,
            endDirty: true,
            endText: value,
        });
    }
    public render() {
        const props = this.props;

        return <>
            <Row ref={this.controlRef}>
                <Col lg={6} md={12}>
                    <FormGroup className="form-group-fix">
                        <Label className="form-label" for={this.props.definition.key + 'start'}>{createLabel(props.definition, true, props.definition.config.startLabel)}</Label>
                        
                        <InputGroup className={(props.showValidation && !props.isValid) ? "is-invalid" : ""} title={createLabel(props.definition, false, props.definition.config.startLabel)}>
                            <Input
                                type="text"
                                aria-label={createLabel(props.definition, false, props.definition.config.startLabel)}
                                id={props.definition.key + 'start'}
                                valid={props.showValidation && props.isValid}
                                invalid={props.showValidation && !props.isValid}
                                readOnly={props.readOnly}
                                placeholder={createLabel(props.definition, true, props.definition.config.startLabel)}
                                onFocus={() => this.onFocus()}
                                onBlur={() => this.onBlur()}
                                onChange={(evt) => this.onChangeStartText(evt.currentTarget.value)}
                                value={this.state.startText}
                            />
                            <InputGroupAddon addonType="append">
                                <Button onClick={() => this.setState({ expand: this.state.expand ? false : 'click' })}>
                                    <i className="mdi mdi-calendar" aria-label="Kalender" />
                                </Button>
                            </InputGroupAddon>
                        </InputGroup>
                    </FormGroup>

                    {this.state.expand &&
                        <Calendar
                            tileClassName={(p) => this.tileClass(p, this.state.startDate)}
                            locale="nl-NL"
                            minDate={this.props.definition.config.minDate ? this.props.definition.config.minDate.toDate() : null}
                            maxDate={this.state.endDate}
                            onActiveStartDateChange={() => this.onFocus()} //handles transfer focus textbox -> calendar
                            onChange={(value: Date) => this.onChangeStart(value)}
                            value={this.state.startDate} />
                    }
                </Col>
                <Col>
                    <FormGroup className="form-group-fix">
                        <Label className="form-label" for={this.props.definition.key + 'end'}>{createLabel(props.definition, true, props.definition.config.endLabel)}</Label>
                       
                        <InputGroup className={(props.showValidation && !props.isValid) ? "is-invalid" : ""} title={createLabel(props.definition, false, props.definition.config.endLabel)}>
                            <Input
                                type="text"
                                aria-label={createLabel(props.definition, false, props.definition.config.endLabel)}
                                id={props.definition.key + 'end'}
                                valid={props.showValidation && props.isValid}
                                invalid={props.showValidation && !props.isValid}
                                readOnly={props.readOnly}
                                placeholder={createLabel(props.definition, true, props.definition.config.endLabel)}
                                onFocus={() => this.onFocus()}
                                onBlur={() => this.onBlur()}
                                onChange={(evt) => this.onChangeEndText(evt.currentTarget.value)}
                                value={this.state.endText}
                            />
                            <InputGroupAddon addonType="append">
                                <Button onClick={() => this.setState({ expand: this.state.expand ? false : 'click' })}>
                                    <i className="mdi mdi-calendar" aria-label="Kalender" />
                                </Button>
                            </InputGroupAddon>
                        </InputGroup>
                    </FormGroup>
                    {this.state.expand &&
                        <Calendar
                            tileClassName={(p) => this.tileClass(p, this.state.endDate)}
                            locale="nl-NL"
                            minDate={this.state.startDate}
                            onActiveStartDateChange={() => this.onFocus()} //handles transfer focus textbox -> calendar
                            onChange={(value: Date) => this.onChangeEnd(value)}
                            value={this.state.endDate} />
                    }
                </Col>
            </Row>
            <Row>
                <Col>
                    {!props.isValid && <FormFeedback style={{display:'block'}} valid={false}>{props.validationMessage}</FormFeedback>}
                </Col>
            </Row>


        </>;
    }
}

export default forBasicControl(enhanceWithClickOutside(DateRangeControl));